<div class="Admindiv w-full p-4 rounded-md">
  <!-- Section Header -->
  <h2 class="text-lg lg:text-xl font-semibold text-gray-900 mb-4 tracking-tight">Admin Controls</h2>

  <!-- 
    Responsive Grid for Shortcut Cards.
    It will show 8 columns on large screens to match the screenshot,
    and fewer columns on smaller screens to remain usable.
  -->
  <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 xl:gap-6">

    <!-- Shortcut 1: Login & Sell Type -->
    <button (click)="navigateTo('set-type')" class="cursor-pointer shortcut-card">
      <div class="icon-container bg-blue-50">
        <i class="fas fa-user-cog text-blue-500"></i>
      </div>
      <span class="shortcut-label">Login, Sell & Logo</span>
    </button>

    <!-- Shortcut 2: Add Category -->
    <button (click)="navigateTo('category-parent')" class="cursor-pointer shortcut-card">
      <div class="icon-container bg-green-50">
        <i class="fas fa-layer-group text-green-500"></i>
      </div>
      <span class="shortcut-label">Add Category</span>
    </button>

    <!-- Shortcut 3: Customize Settings -->
    <button (click)="navigateTo('dropdown-setting')" class="cursor-pointer shortcut-card">
      <div class="icon-container bg-yellow-50">
        <i class="fas fa-sliders-h text-yellow-500"></i>
      </div>
      <span class="shortcut-label">Customize Settings</span>
    </button>

    <!-- Shortcut 4: Karigar List -->
    <button (click)="navigateTo('list-kalakar')" class="cursor-pointer shortcut-card">
      <div class="icon-container bg-purple-50">
        <i class="fas fa-users text-purple-500"></i>
      </div>
      <span class="shortcut-label">Karigar List</span>
    </button>

    <!-- Shortcut 5: Invoice Layout -->
    <button (click)="navigateTo('admin-customize-invoice')" class="cursor-pointer shortcut-card">
      <div class="icon-container bg-red-50">
        <i class="fas fa-file-invoice-dollar text-red-500"></i>
      </div>
      <span class="shortcut-label">Invoice Layout</span>
    </button>

    <!-- Shortcut 6: Assets -->
    <button (click)="navigateTo('asset-form')" class="cursor-pointer shortcut-card">
      <div class="icon-container bg-indigo-50">
        <i class="fas fa-gem text-indigo-500"></i>
      </div>
      <span class="shortcut-label">Assets</span>
    </button>

    <!-- Shortcut 7: Rate List -->
    <button (click)="navigateTo('rate-List')" class="cursor-pointer shortcut-card">
      <div class="icon-container bg-pink-50">
        <i class="fas fa-rupee-sign text-pink-500"></i>
      </div>
      <span class="shortcut-label">Rate List</span>
    </button>

    <!-- Shortcut 8: Staff List -->
    <button (click)="navigateTo('stafflistadmin')" class="cursor-pointer shortcut-card">
      <div class="icon-container bg-gray-100">
        <i class="fas fa-user-tie text-gray-600"></i>
      </div>
      <span class="shortcut-label">Staff List</span>
    </button>
    
  </div>
</div>